export default "__VITE_ASSET__6c3d9ec0__"